module.exports = __webpack_public_path__ + "static/media/private.a4093739.svg";